import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import CustomerOverview from './components/customer/customerOverview';
import CustomerForm from './components/customer/customerForm';
import CustomerDetails from './components/customer/customerDetails';
import Login from './components/auth/login/login';
import ForgotPassword from './components/auth/forgot-password/page';
import ResetPassword from './components/auth/reset-password/page';
import SetPassword from './components/auth/set-password/page';
import LoginSSO from './components/auth/login/LoginSSO';
import OrdersMain from './components/orders/OrdersMain';
import OrderDetails from './components/orders/OrderDetails';
import LicensesMain from './components/licenses/LicensesMain';
import withAuth from "./components/auth/withAuth";
import AccordianTest from './components/customer/accordian';
import { ToastContextProvider } from './context/toastContext';
import UserManagement from './components/user/user';
import CustomerViews from './components/customer/customerView';
import OrderCreate from './components/orderCreate/OrderCreate';
import { PartnerIdContextProvider } from './context/partnerIdContext';
import Layout from './components/Layout';
import AdminMain from './components/admin/AdminMain';
// import AuditTrail from './components/admin/audit/AuditTrail';
import UsersMain from './components/admin/users/UsersMain';
import PlatformMain from './components/admin/platform/PlatformMain';

import withAdminPlatform from './components/auth/withAdminPlatform';
import AdminGuard from './components/auth/AdminGuard';
import AuthGuard from './components/auth/AuthGuard';
import { PROFILE_TYPE } from './helper/globalConstant';
import ProtectedRoute from './components/route/ProtectedRoute';
const AdminPlatformProtected = withAdminPlatform(PlatformMain);

const INTEGRATORS_AND_TECHNICIANS = [
  PROFILE_TYPE.INTEGRATOR,
  PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1,
  PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2,
];

function App() {
  return (
    <PartnerIdContextProvider>
      <ToastContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Layout />}>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<LoginRouteHandler />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/set-password" element={<SetPassword />} />

              {/* Protected Routes */}
              <Route element={<AuthGuard />}>
                <Route path="/customer/overview" element={<CustomerOverview />} />
                {/* SUPER_ADMIN and DISTRIBUTOR cannot access /customer/new */}
              <Route element={<ProtectedRoute allowedRoles={INTEGRATORS_AND_TECHNICIANS} />}>
                <Route path="/customer/new" element={<CustomerForm />} />
              </Route>
                <Route path="/customer/details/:companyName/:id" element={<CustomerDetails />} />
                <Route path="/customer/view/:companyName/:sitename/:id" element={<CustomerViews />} />
                <Route path="/orders" element={<OrdersMain />} />
                <Route path="/orders/details" element={<OrderDetails />} />
                <Route path="/licenses" element={<LicensesMain />} />
                <Route path="/orders/create" element={<OrderCreate />} />

                {/* Admin specific routes */}
                <Route element={<AdminGuard />}>
                  <Route path="/admin" element={<AdminMain />} />
                  <Route path="/admin/platform" element={<AdminPlatformProtected />} />
                  <Route path="/admin/:entityType" element={<UsersMain />} />
                </Route>

              </Route>

            </Route>
          </Routes>
        </Router>
      </ToastContextProvider>
    </PartnerIdContextProvider>
  );
}

const LoginRouteHandler = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  if (queryParams.has('mo_fb_jwt_token')) {
    return <LoginSSO />;
  }
  return <Login />;
}

export default App;
